import { NextQuery } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_MUTATIONS_KEYS } from '../query-signals.const';
import { QuerySignalsMutation } from '../query-signals.interfaces';

export class SetLastNextQueryLoadedMutation implements QuerySignalsMutation {

  mutations = {
    [QUERY_SIGNALS_MUTATIONS_KEYS.setLastNextQueryLoaded]: (querySignalsState: QuerySignalsState, lastNextQueryLoaded: NextQuery) => {
      querySignalsState.lastNextQueryLoaded = lastNextQueryLoaded;
    },
    [QUERY_SIGNALS_MUTATIONS_KEYS.resetNextQueryResults]: (querySignalsState: QuerySignalsState) => {
      querySignalsState.lastNextQueryLoaded = null;
      querySignalsState.nextQueries
        .filter(nextQuery => nextQuery.numFound)
        .forEach(nextQuery => {
          nextQuery.results = [];
          nextQuery.numFound = 0;
        });
    }
  };
}
